import React from 'react';

import { useProduct } from '../../hooks/useProduct'
import * as constants from '../../constants'
import AbstractBestPracticeList from '../AbstractBestPracticeList'


export default function(props) {
  const productDetails = useProduct()
  return (
    <AbstractBestPracticeList
      category={constants.CATEGORY_MAINTAINABILITY}
      title={'Python maintainability best practice'}
      seoTitle={'Python maintainability best practice'}
      svgPath='/money.svg'
      synopsis_parageaph_one={`${productDetails.name} suggests a fix if your code does not follows Python maintainability best practices.`}
      synopsis_parageaph_two='This frees your team to be more agile - they can focus on adding value rather than fighting with old tech debt.'
    />
  );
}
